module.exports = __webpack_public_path__ + "media/images/flavours/icon-agrume_dark-dee3796bd69b19c3c2cee6486956e514.png";